import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import App from './Blog';
import { CookieManager } from "react-cookie-manager";

ReactDOM.createRoot(document.querySelector("#root")!).render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
       <CookieManager>
      <App/>
      </CookieManager>
    </StyledEngineProvider>
  </React.StrictMode>
);